import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TippyProps } from '../hint/hint.types';

let nextUniqueId = 0;
@Component({
  selector: `[bll-tooltip], bll-tooltip`,
  exportAs: 'bllTooltip',
  host: {
    class: 'tw-inline-block tw-text-primary hide-exporttool',
    '[attr.id]': 'id',
    '[attr.tabindex]': '-1',
  },
  template: `<i
      class="tw-block tw-rounded-full tw-border-primary tw-border"
      [ngClass]="'icon-' + icon"
      [bllHint]="content"
    ></i
    ><ng-content></ng-content>`,
  styles: [
    `
      :host i {
        padding: 3px;
        font-size: 12px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BllTooltipComponent {
  @Input() id = `bll-tooltip-${nextUniqueId++}`;
  @Input() icon = 'question';
  @Input() content: string;
  @Input() placement: TippyProps['placement'];
  @Input() trigger: TippyProps['trigger'] = 'mouseenter focus';
}
